import React from 'react';
import { WORKFLOW_STEPS } from './WorkflowProgressBar';

export default function WorkbenchBottomBar({
  activeTab,
  onSelectTab,
  onSaveDraft,
  onToggleCritical,
  onOpenReportModal,
  onReleaseReport,
  isCritical,
  isApproved,
  isReadyForFinal,
  saveState,
  lastSavedTime,
  saving
}) {
  const currentStepIdx = WORKFLOW_STEPS.findIndex((s) => s.id === activeTab);
  const currentStep = WORKFLOW_STEPS[currentStepIdx] || WORKFLOW_STEPS[0];

  const prevStep = currentStepIdx > 0 ? WORKFLOW_STEPS[currentStepIdx - 1] : null;
  const nextStep = currentStepIdx < WORKFLOW_STEPS.length - 1 ? WORKFLOW_STEPS[currentStepIdx + 1] : null;

  return (
    <footer className="wb-sticky-action-bar">
      {/* Left: Secondary actions & Safety toggles */}
      <div className="wb-action-bar-left">
        <button
          type="button"
          className="wb-btn-secondary-clinical"
          disabled={saving}
          onClick={onSaveDraft}
          title="Save draft observations without advancing"
        >
          {saving ? 'Saving Draft...' : 'Save Draft'}
        </button>

        <button
          type="button"
          className={`wb-btn-critical-flag ${isCritical ? 'active' : ''}`}
          onClick={onToggleCritical}
          title="Toggle urgent hospital infection control alert flag"
        >
          {isCritical ? '🚨 Critical Alert Active' : 'Flag Critical Result'}
        </button>
      </div>

      {/* Center: Current step context & save feedback */}
      <div className="wb-action-bar-center">
        <span>
          <strong>Step {currentStep.stepNo} of 7:</strong> {currentStep.label}
        </span>
        {saveState === 'saved' && lastSavedTime && (
          <span style={{ color: '#15803d', fontWeight: '600' }}>&bull; Saved at {lastSavedTime}</span>
        )}
        {saveState === 'unsaved' && (
          <span style={{ color: '#d97706', fontWeight: '600' }}>&bull; Unsaved changes</span>
        )}
      </div>

      {/* Right: Stage Navigation & Primary Approval */}
      <div className="wb-action-bar-right">
        {prevStep && (
          <button
            type="button"
            className="wb-btn-secondary-clinical"
            onClick={() => onSelectTab(prevStep.id)}
            title={`Return to Step ${prevStep.stepNo}: ${prevStep.label}`}
          >
            &larr; {prevStep.shortLabel}
          </button>
        )}

        <button
          type="button"
          className="wb-btn-secondary-clinical"
          onClick={onOpenReportModal}
          title="Preview Official Diagnostic Report"
        >
          Preview Report
        </button>

        {nextStep && (
          <button
            type="button"
            className="wb-btn-primary-clinical"
            onClick={() => onSelectTab(nextStep.id)}
            title={`Advance to Step ${nextStep.stepNo}: ${nextStep.label}`}
          >
            Continue to {nextStep.shortLabel} &rarr;
          </button>
        )}

        {currentStep.id === 'validation' && !isApproved && (
          <button
            type="button"
            className="wb-btn-release-clinical"
            disabled={!isReadyForFinal}
            onClick={() => onReleaseReport('Final')}
            title={isReadyForFinal ? 'Authorize and release final immutable diagnostic report' : 'Complete mandatory requirements before final release'}
          >
            ✓ Approve & Release Final Report
          </button>
        )}
      </div>
    </footer>
  );
}
